import * as THREE from "three";
import TextureLoader from '../../custom/TextureLoader.js';
import {doc} from '../docs.js';

doc(
    "three.dataTexture",
    {
        dataArray: "",
        width: "",
        height: "",
    },
    "Creates a three.js data texture out of an array of data and optional width/height",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const dataTexture = (object, width, height) => {
    let data = undefined;
    let _texture;
    return ([msg]) => {
        if (!Array.isArray(msg) && !ArrayBuffer.isView(msg)) {
            return undefined;
        }

        let _width = width() || Math.round(Math.sqrt(msg.length));
        let _height = height() || Math.round(Math.sqrt(msg.length));
        if (!ArrayBuffer.isView(msg)) {
            if (!data || data.length !== msg.length) {
                data = new Uint8Array(_width*_height*4);
            }
            if (msg.length <= data.length) {
                data.set(msg);
            } else {
                data.set(msg.slice(0, data.length));
            }
        } else {
            data = msg;
        }
        if (!_texture || _texture.width !== _width || _texture.height !== _height ||
            _texture.data.length !== data.length) {
            _texture= new THREE.DataTexture(data, _width, _height, THREE.RGBAFormat,
                                            undefined, undefined, undefined, undefined, undefined,  );
        } else {
            _texture.image.data = data;
            _texture.needsUpdate = true;

        }
        return _texture;
    };
};

doc(
    "three.textureLoader",
    {
    },
    "Load images into three.js textures",
    () => 0);
const textureLoader = (object) => {
    object.effect = new TextureLoader(object);
    object.needsLoad = true;
    return ([]) => {
        if (object.effect.imageHash) {
            object.effect.loadImage(object.effect.imageHash);
        }
    };
};

export const texture ={
    "three.dataTexture": dataTexture,
    "three.textureLoader": textureLoader,
};
